import * as React from "react";
import { getFunctionHandler } from "../../../../constants";
import { FreeBet } from "./FreeBet";
import { OddsBoost } from "./OddsBoost";
import { ProfitBoost } from "./ProfitBoost";
import { EarlyWin } from "./EarlyWin";
import { QualifyingBet } from "./QualifyingBet";
import { GuaranteedPayout } from "./GuaranteedPayout";
const mapBonuses = new Proxy({
    FREE_BET: FreeBet,
    ODDS_BOOST_FIXED: OddsBoost,
    ODDS_BOOST_EXTENSION: OddsBoost,
    ODDS_BOOST_PERCENTAGE: ProfitBoost,
    PROFIT_BOOST: ProfitBoost,
    EARLY_WIN: EarlyWin,
    QUALIFYING_BET: QualifyingBet,
    GUARANTEED_PAYOUT: GuaranteedPayout,
}, getFunctionHandler);
export const PlayerBonus = React.memo(function PlayerBonus(props) {
    const { playerBonus, purchaseId, testId } = props;
    const Bonus = mapBonuses[playerBonus.type];
    return React.createElement(Bonus, Object.assign({}, props.playerBonus, { purchaseId: purchaseId, testId: testId }));
});
//# sourceMappingURL=PlayerBonus.js.map